import React from "react";
import { Box, Button, Typography } from "@mui/material";

import heroBackground from "../../../static/images/distant_amplifier_bundle/hero-background.webp";
import { INCLUDED_PRODUCTS } from "./data";

// Adapted from BassDistant/MainBanner, with isolated bundle artwork and styling.
const MainBanner = ({ children }: { children: React.ReactNode }) => (
  <Box component="section" aria-labelledby="distant-bundle-title" sx={{
    backgroundImage: `linear-gradient(90deg, rgba(13, 11, 10, 0.96), rgba(13, 11, 10, 0.63)), url(${heroBackground})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    px: { xs: 3, sm: 5 },
    pt: { xs: 14, sm: 17 },
    pb: { xs: 7, sm: 10 },
  }}>
    <Box sx={{ maxWidth: "1280px", mx: "auto", display: "grid", gridTemplateColumns: { xs: "1fr", md: "0.9fr 1.1fr" }, gap: { xs: 5, md: 7 }, alignItems: "center" }}>
      <Box>
        <Button href="/store#bundles" size="small" sx={{ color: "#e0d6cb", px: 0, mb: 2 }}>← Plugin Bundles</Button>
        <Typography sx={{ color: "#ddd", letterSpacing: "0.18em", textTransform: "uppercase", fontSize: "0.75rem", fontWeight: 650, mb: 1.5 }}>
          Guitar + Bass
        </Typography>
        <Typography id="distant-bundle-title" variant="h1" sx={{ fontSize: { xs: "2.75rem", sm: "4rem" }, lineHeight: 1.08, fontWeight: 650 }}>
          Distant Tone Bundle
        </Typography>
        <Typography sx={{ fontSize: { xs: "1.2rem", sm: "1.5rem" }, mt: 2, mb: 2 }}>
          Two suites. One massive sound.
        </Typography>
        <Typography sx={{ color: "#d4cec7", fontSize: "1rem", lineHeight: 1.8, maxWidth: "520px" }}>
          Bring ToneSuite - Distant and BassSuite - Distant together.
          Crushing guitars, physical low end, and the tools to build your own wall of sound.
        </Typography>
        {children}
        <Button href="#included-products" variant="text" sx={{ mt: 2, px: 0, color: "#e0d6cb" }}>Explore the included plugins ↓</Button>
      </Box>
      <Box sx={{ display: "grid", gap: 3, minWidth: 0 }}>
        {INCLUDED_PRODUCTS.map((product) => <Box component="figure" key={product.id} sx={{ m: 0, width: { xs: "100%", md: "90%" }, justifySelf: product.instrument === "Bass" ? "end" : "start" }}>
          <img src={product.image} alt={`${product.name} plugin interface`} width={product.width} height={product.height} loading="eager" decoding="async" style={{ display: "block", width: "100%", height: "auto", maxHeight: "310px", objectFit: "contain", filter: "drop-shadow(0 12px 24px rgba(0,0,0,0.5))" }} />
          <Typography component="figcaption" sx={{ mt: 1, textAlign: "center", fontSize: "0.8rem", color: "#ddd5cc" }}>{product.name}</Typography>
        </Box>)}
      </Box>
    </Box>
  </Box>
);

export default MainBanner;
